'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('docketListController', function ($rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, orderService) {

    //$("body").css('touch-action','');

    /***************************/
    /***** Setup Variables *****/
    /***************************/

    var viewMode = "default";

    $scope.moment = moment;
    $scope.listItems = [];
    $scope.listCount = 0;
    $scope.docketsLoading = false;
    //$scope.listFull = true;

    $scope.listViewConfig = {
      docketNumber: { displayName: "Docket Number", modelName: 'docketNumber' },
      customerName: { displayName: "Customer", modelName: 'customerName' },
      supplierName: { displayName: "Supplier", modelName: 'supplierName' },
      authorName: { displayName: "Operator", modelName: 'authorName' },
      customerSignatureName: { displayName: "Signed By", modelName: 'customerSignatureName' },
      date: { displayName: "Date", modelName: 'date' },
      status: { displayName: "Status", modelName: 'status' },
      customerRefNo: { displayName: "Customer Ref No", modelName: 'customerRefNo' },
      supplierRefNo: { displayName: "Supplier Ref No", modelName: 'supplierRefNo' },
      acceptedBy: { displayName: "Accepted By", modelName: 'acceptedBy' },
      orderNumber: { displayName: "Order Number", modelName: '' }
    };

    $scope.listViewInjectCustomFields = [];
    $scope.listViewInjectOrderNumbers = false;

    if (viewMode == 'default') {
      $scope.listViewOrder = ['docketNumber', 'customerName', 'supplierName', 'authorName', 'date', 'status'];
    } else if (viewMode == 'receiver') {
      $scope.listViewOrder = ['docketNumber', 'supplierName', 'authorName', 'customerSignatureName', 'date', 'status'];
    }

    if ($scope.currentOrg && $scope.currentOrg.features && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.listViewOrder && $scope.currentOrg.features.dockets.listViewOrder.length > 0) {
      $scope.listViewOrder = $scope.currentOrg.features.dockets.listViewOrder;
      for (var i = 0; i < $scope.listViewOrder.length; i++) {
        if ($scope.listViewOrder[i].indexOf('customField') == 0) {
          $scope.listViewInjectCustomFields.push($scope.listViewOrder[i].split('-')[1]);
          // generate a nice display name for this custom field column
          var niceDisplayName = $scope.listViewOrder[i].split('-')[1].match(/[A-Z][a-z,1-9]+/g).join(' ');
          $scope.listViewConfig[$scope.listViewOrder[i]] = { displayName: niceDisplayName, modelName: '' };
        } else if ($scope.listViewOrder[i] == 'orderNumber') {
          $scope.listViewInjectOrderNumbers = true;
        }
      }
    }

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    $scope.selectedItem = null;

    /***********************/
    /***** Permissions *****/
    /***********************/

    /* F/E Permission Checking */
    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    /*******************************/
    /***** Major State Changes *****/
    /*******************************/

    $scope.$parent.updateSelectedDocketFromParent = function (docket) {
      $scope.selectedItem = docket;
    }

    $scope.$parent.prepareForDocketsFromParent = function () {
      $scope.listItems = [];
      $scope.docketsLoading = true;
    }

    $scope.$parent.injectCustomFields = function (docketsList) {
      if ($scope.listViewInjectCustomFields.length > 0) {
        $scope.injectCustomFieldsIntoDocketsList(docketsList, $scope.listViewInjectCustomFields);
      }
    }

    $scope.$parent.loadDocketsListFromParent = function (docketsList, docketCount) {
      $scope.listItems = docketsList;
      $scope.injectCustomFields(docketsList)
      if ($scope.listViewInjectOrderNumbers) {
        $scope.$parent.injectOrderNumbersIntoDocketsList($scope.listItems);
      }
      $scope.listCount = docketCount;
      $scope.docketsLoading = false;
    }

    $scope.$parent.loadAdditionalDocketsFromParent = function (docketsList) {
      for (var i = 0; i < docketsList.length; i++) {
        $scope.listItems.push(docketsList[i]);
      }
    }

    $scope.$parent.loadInDocketFiledStatusFromParent = function (docketsFiledStatus) {
      for (var i = 0; i < $scope.listItems.length; i++) {
        if (docketsFiledStatus[$scope.listItems[i].id]) {
          $scope.listItems[i].filed = true;
        } else {
          $scope.listItems[i].filed = false;
        }
      }

      if ($scope.filters.filedOptions.display && !$scope.filters.filedOptions.all && $scope.filters.filedOptions.filed != $scope.filters.filedOptions.unfiled) {
        if ($scope.filters.filedOptions.filed) {
          $scope.listItems = $scope.listItems.filter(item => item.filed)
        } else {
          $scope.listItems = $scope.listItems.filter(item => !item.filed)
        }
      }
    }

    $scope.injectCustomFieldsIntoDocketsList = function (docketsList, customFieldsToInject) {
      for (var i = 0; i < docketsList.length; i++) {
        var thisDocket = docketsList[i];
        thisDocket.customFieldsInjected = {};
        if (thisDocket.template && thisDocket.template.blocks) {
          for (var j = 0; j < thisDocket.template.blocks.length; j++) {
            for (var k = 0; k < thisDocket.template.blocks[j].fields.length; k++) {
              var thisFieldName = thisDocket.template.blocks[j].fields[k].displayName;
              var thisFieldNameReduced = thisFieldName.split(' ').join('');
              // now check if this custom field matches one from the to inject list
              if (customFieldsToInject.indexOf(thisFieldNameReduced) != -1) {
                // get the templateValueStore value for this custom field
                if (thisDocket && thisDocket.templateValueStore && thisDocket.templateValueStore[thisDocket.template.blocks[j].id + '-' + thisDocket.template.blocks[j].fields[k].id]) {
                  thisDocket.customFieldsInjected[thisFieldNameReduced] = thisDocket.templateValueStore[thisDocket.template.blocks[j].id + '-' + thisDocket.template.blocks[j].fields[k].id];
                }
              }
            }
          }
        }
      }
    }

    $scope.injectOrderNumbersIntoDocketsList = function (docketsList) {
      // first we need to get a unique list of order uuid's
      var orderIds = {};
      for (var i = 0; i < docketsList.length; i++) {
        if (docketsList[i].orderRef && !orderIds[docketsList[i].orderRef]) {
          orderIds[docketsList[i].orderRef] = true;
        }
      }

      // now we need to get the orders for the list of ids that we generated
      orderService.getOrders({ ids: Object.keys(orderIds).join(',') }, function (orders) {
        var orderNumbers = {};
        for (var i = 0; i < orders.length; i++) {
          orderNumbers[orders[i].id] = orders[i].orderNumber;
        }
        // now that we have the full orders - we need to inject the orderNumber into each docket list item
        for (var i = 0; i < docketsList.length; i++) {
          if (docketsList[i].orderRef && orderNumbers[docketsList[i].orderRef]) {
            docketsList[i].orderNumber = orderNumbers[docketsList[i].orderRef];
          }
        }
      }, function (failed) {
        console.error('could not get list of orders', failed);
      });
    }

    /*************************************/
    /***** Item List / Swipe Actions *****/
    /*************************************/

    // TODO: change this for desktop options - not used in mobile
    $scope.openDocket = function (docket) {
      $scope.itemEdit = {};
      $scope.openDocketDesktop(docket);
    }

    /**************************************************/
    /***** Alert parent controller of ready state *****/
    /**************************************************/

    $scope.$parent.docketsChildControllerReady();

  });



// WEBPACK FOOTER //
// ./src/controllers/dockets/listController.js